/**
 * 文章列表
 */
import Layout from '../../pages/layout/Frame';

const articleRouter = {
    path: "/article",
    component: Layout,
    meta: {title: '文章管理'},
    name: "article_list",
    children: [
        {
            path: "/article/index",
            component: () => import('../../pages/article/Index.vue'),
            meta: {title: '文章列表',},
            name: 'article_list',
        },
        {
            path: "/article/create",
            component: () => import('../../pages/article/Create.vue'),
            meta: {title: '创建文章',},
            name: 'article_list',
        },
        {
            path: "/article/edit",
            component: () => import('../../pages/article/Edit.vue'),
            meta: {title: '修改文章',},
            name: 'article_list',
        },
    ]
};

export default articleRouter
